import React from 'react';

/**
 * Renders a widget component based on the provided item and its properties.
 *
 * @param {object} item
 * @param {object} item.presentation
 * @param {string} item.presentation.size
 * @param {object} item.widget
 * @param {string} item.widget.name
 * @param {object} item.widget.properties
 * @param {React.ReactElement} AdvancedEmbed
 * @param {React.ReactElement} MenuEmbed
 * @param {Function} getDataActivityMapID
 * @param {number} i
 * @returns {React.ReactElement|null}
 */
export function getWidgetComponent(
  item,
  AdvancedEmbed,
  MenuEmbed,
  getDataActivityMapID,
  i,
) {
  if (!item?.widget) {
    return null;
  }

  const advEmbItem = {
    ...item,
    widget: {
      ...(item?.widget),
      properties: {
        ...(item?.widget?.properties),
        'embed-code': item.widget.properties?.embed?.code,
      },
    },
  };

  return (
    <AdvancedEmbed
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...advEmbItem}
      key={i}
      MenuEmbed={MenuEmbed}
      getDataActivityMapID={getDataActivityMapID}
    />
  );
}
